module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("sub-table-temp-associated_device")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f141d688","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub_pages/sub-table-temp-associated_device.vue
// module id = 1071
// module chunks = 0